import { gql } from '@apollo/client';
import { Location } from 'history';

import { GraphQLTypes } from 'src/lib/graphqlTypes';

import {
  taskToTaskType,
  taskToTaskTypeTaskFragment,
} from '../../check/CheckTask/taskToTaskType';
import { useInternalGraphLinking } from '../../hooks/useInternalGraphLinking';

export const getLinkToTaskWorkflowTaskFragment = gql`
  fragment getLinkToTaskWorkflowTaskFragment on CheckWorkflowTask {
    id
    status
    ...taskToTaskTypeTaskFragment
  }
  ${taskToTaskTypeTaskFragment}
`;

export const getLinkToTaskWorkflowFragment = gql`
  fragment getLinkToTaskWorkflowFragment on CheckWorkflow {
    id
    baseVariant {
      id
      name
    }
  }
`;
export function getLinkToTask(
  task: GraphQLTypes.getLinkToTaskWorkflowTaskFragment,
  workflow: GraphQLTypes.getLinkToTaskWorkflowFragment,
  location: Location,
  internalGraphLinking: ReturnType<typeof useInternalGraphLinking>,
) {
  const taskType = taskToTaskType(task);
  const canLinkToTask = [
    GraphQLTypes.CheckWorkflowTaskStatus.PASSED,
    GraphQLTypes.CheckWorkflowTaskStatus.FAILED,
  ].includes(task.status);
  // don't return anything / task is not linkable
  if (canLinkToTask === false || taskType === 'unknown') return undefined;

  const { isProposalRoute, currentVariantRouteConfig, currentCheckTasksRoute } =
    internalGraphLinking;

  return currentCheckTasksRoute.locationFrom({
    location,
    fromRouteConfig: currentVariantRouteConfig,
    patch: {
      ...(isProposalRoute ? {} : { graphVariant: workflow.baseVariant?.name }),
      checkId: workflow.id,
      taskType,
    },
  });
}
